import React, { FC } from 'react'
import { Col, List, Row } from 'antd'
import { SeatCard } from './SeatCard'
import { usePaymentMethod } from '../hooks'

export const SeatList: FC = () => {

  const { seatProducts } = usePaymentMethod()

  return (
    <Row 
      justify={'center'} 
      align={'middle'}
      gutter={[16, 16]}
    >
      <Col span={18}>
        <Row justify={'center'} align={'middle'} gutter={[16, 16]}>
        {seatProducts?.map(s => 
          <Col xs={24} sm={24} md={12} lg={12} key={s.price.id}>
            <SeatCard productDetails={s} />
          </Col>
        )}
        </Row>
      </Col>
    </Row>
  )
}
